import { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { PhoneCall } from "lucide-react";

export default function CallbackForm({ dark = false }) {
  const [form, setForm] = useState({ name: "", contact: "", location: "" });
  const [busy, setBusy] = useState(false);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.contact.trim()) { toast.error("Please enter your name and contact number"); return; }
    setBusy(true);
    try {
      const { data } = await api.post("/site/callback", form);
      toast.success(data.message || "Thank you — we'll call you back shortly.");
      setForm({ name: "", contact: "", location: "" });
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail) || err.message); }
    finally { setBusy(false); }
  };

  const label = dark ? "text-white/60" : "text-[#525252]";
  const input = `w-full rounded-xl border p-4 text-sm outline-none transition-colors duration-200 focus:border-[var(--rgh-primary)] ${
    dark ? "bg-white/5 border-white/15 text-white placeholder:text-white/30" : "bg-white border-[#E5E5E5] text-[#0A0A0A] placeholder:text-[#A3A3A3]"
  }`;

  return (
    <form onSubmit={submit} data-testid="callback-form" className="space-y-4">
      <div className="grid sm:grid-cols-3 gap-4">
        <div>
          <label className={`block text-xs font-medium mb-2 ${label}`}>Full name</label>
          <input data-testid="callback-name" className={input} value={form.name} onChange={(e) => set("name", e.target.value)} placeholder="Your name" />
        </div>
        <div>
          <label className={`block text-xs font-medium mb-2 ${label}`}>Contact number</label>
          <input data-testid="callback-contact" className={input} value={form.contact} onChange={(e) => set("contact", e.target.value)} placeholder="+234 …" />
        </div>
        <div>
          <label className={`block text-xs font-medium mb-2 ${label}`}>Location</label>
          <input data-testid="callback-location" className={input} value={form.location} onChange={(e) => set("location", e.target.value)} placeholder="City / State" />
        </div>
      </div>
      <button type="submit" disabled={busy} data-testid="callback-submit"
        className="inline-flex items-center gap-2 rounded-full bg-[var(--rgh-primary)] px-7 py-3.5 text-sm font-semibold text-white transition-[transform,background-color,box-shadow] duration-200 hover:bg-[var(--rgh-primary-dark)] hover:-translate-y-0.5 hover:shadow-lg disabled:opacity-60">
        <PhoneCall size={16} /> {busy ? "Sending…" : "Request a callback"}
      </button>
    </form>
  );
}
